<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>

      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{fullName}}
            </p>
            <span class="user-status">{{role}}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/profile-icon.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profil</span>
        </b-dropdown-item>

        <b-dropdown-item @click="dark" link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
            class="mr-50"
          />
          <span>{{isDark ? 'Gündüz Modu' : 'Gece Modu' }}</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item v-on:click="logout" link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Çıkış Yap</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import useAppConfig from '@core/app-config/useAppConfig'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Auth from '@/utilities/auth'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed:{
    fullName(){
      return [Auth.user.FirstName, Auth.user.LastName].join(' ')
    },
    role(){
      return Auth.role
    },
    isDark(){
      const { skin } = useAppConfig()
      return skin.value === 'dark' ? true : false
    }
  },
  methods: {
    logout() {
      Auth.isAuthenticated = false
      Auth.user = {}
      Auth.clearCustomerData()
      this.$router.push({ name: 'login' })
    },
    dark(){
      const { skin } = useAppConfig()
      skin.value = this.isDark ? 'light' : 'dark'
    }
  },
}
</script>
